module.exports = __webpack_public_path__ + "img/75606.adf460b7.svg";